import React from 'react'
import { useQuery } from 'react-apollo'

import AccountHeader from '../AccountHeader/AccountHeader'
import Button from '../Button/Button'
import Error from '../Error/Error'
import { OrdersList } from './OrderList/OrdersList'
import { NoOrders } from './NoOrders/NoOrders'
import { LoadingOrdersList } from './LoadingOrdersList/LoadingOrdersList'
import { useRestaurant } from '../RestaurantProvider/RestaurantProvider'
import { GET_PAGINATED_ORDERS } from '../../apollo/orders/orders.graphql'
import { Notification } from '../Notification/Notification'
import { useAvailability } from '../../utils/availability'

import './MyOrdersPage.css'

export const MyOrdersPage = () => {
  const { getRestaurantPath, restaurantGuid } = useRestaurant()
  const { loading: availabilityLoading, orderingAvailable } = useAvailability()
  const { data, loading, error, fetchMore } = useQuery(GET_PAGINATED_ORDERS, {
    variables: {
      input: {
        restaurantGuid,
        limit: 10
      }
    },
    notifyOnNetworkStatusChange: true
  })

  const loadNextBatch = () => {
    fetchMore({
      variables: {
        input: {
          offset: data.paginatedOrders.orders.length,
          limit: 10,
          restaurantGuid
        }
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev
        return Object.assign({}, prev, {
          paginatedOrders: {
            totalSize: fetchMoreResult.paginatedOrders.totalSize,
            orders: [...prev.paginatedOrders.orders, ...fetchMoreResult.paginatedOrders.orders],
            __typename: fetchMoreResult.paginatedOrders.__typename
          }
        })
      }
    })
  }

  const orders = data ? data.paginatedOrders.orders : null
  const shouldShowEmpty = data && data.paginatedOrders.totalSize === 0
  const moreOrders = data && data.paginatedOrders.totalSize - data.paginatedOrders.orders.length

  return (
    <div styleName='page'>
      {!availabilityLoading && !orderingAvailable && (
        <div styleName='notificationsContainer'>
          <Notification>
            Ordering online is currently not available.
          </Notification>
        </div>
      )}
      <AccountHeader to={getRestaurantPath()} title='My Orders' />
      <div styleName='orderListContainer'>
        {orders && <OrdersList orders={orders} />}
        {loading && <LoadingOrdersList count={moreOrders} />}
      </div>
      {shouldShowEmpty && <NoOrders />}
      {error && <Error />}
      {Boolean(moreOrders) && !loading &&
        <div styleName='viewMoreButton'>
          <Button
            style='link'
            onClick={loadNextBatch}
            id='view-more-button'>
              View More
          </Button>
        </div>
      }
    </div>
  )
}
